import styled from 'styled-components'

export const Circle = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin: 0 auto;
  background: ${({ color }) => color || '#D3D3D3'};
`
